import { jsx as _ } from "react/jsx-runtime";
import { R as n } from "./chunks/index.DwnHX4bj.js";
import { icons as l } from "@smart/react-icons";
import { c as i } from "./chunks/index.rKuIKazb.js";
import p from "react";
import { j as f, r as u, L as C } from "./chunks/layout.BROMuy9M.js";
import './assets/icon.css';const y = "_icon_gotj8_3", t = {
  icon: y,
  "mode-100": "_mode-100_gotj8_6",
  "mode-100-xs": "_mode-100-xs_gotj8_12",
  "mode-100-sm": "_mode-100-sm_gotj8_19",
  "mode-100-md": "_mode-100-md_gotj8_26",
  "mode-100-lg": "_mode-100-lg_gotj8_33",
  "mode-100-xl": "_mode-100-xl_gotj8_40",
  "mode-100-xxl": "_mode-100-xxl_gotj8_47",
  "mode-200": "_mode-200_gotj8_53",
  "mode-200-xs": "_mode-200-xs_gotj8_59",
  "mode-200-sm": "_mode-200-sm_gotj8_66",
  "mode-200-md": "_mode-200-md_gotj8_73",
  "mode-200-lg": "_mode-200-lg_gotj8_80",
  "mode-200-xl": "_mode-200-xl_gotj8_87",
  "mode-200-xxl": "_mode-200-xxl_gotj8_94",
  "mode-300": "_mode-300_gotj8_100",
  "mode-300-xs": "_mode-300-xs_gotj8_106",
  "mode-300-sm": "_mode-300-sm_gotj8_113",
  "mode-300-md": "_mode-300-md_gotj8_120",
  "mode-300-lg": "_mode-300-lg_gotj8_127",
  "mode-300-xl": "_mode-300-xl_gotj8_134",
  "mode-300-xxl": "_mode-300-xxl_gotj8_141",
  "mode-400": "_mode-400_gotj8_147",
  "mode-400-xs": "_mode-400-xs_gotj8_153",
  "mode-400-sm": "_mode-400-sm_gotj8_160",
  "mode-400-md": "_mode-400-md_gotj8_167",
  "mode-400-lg": "_mode-400-lg_gotj8_174",
  "mode-400-xl": "_mode-400-xl_gotj8_181",
  "mode-400-xxl": "_mode-400-xxl_gotj8_188"
}, k = Array.from(
  new Set(
    Object.keys(l).map((o) => o.replace("--small", "")).map((o) => o.replace("--medium", ""))
  )
), N = p.forwardRef(
  ({
    icon: o,
    mode: m = 200,
    color: g,
    className: x,
    "aria-label": e,
    ...j
  }, a) => {
    let d = `${o}--small`;
    (m === 300 || m === 400) && (d = `${o}--medium`);
    const r = l[d], c = i(
      t.icon,
      f(u("mode", m), t),
      x
    ), s = /* @__PURE__ */ _(C, { color: g, asChild: !0, children: /* @__PURE__ */ _(r, { ref: a, className: c, ...j }) });
    return e ? /* @__PURE__ */ _(n, { label: e, children: s }) : s;
  }
);
N.displayName = "Icon";
export {
  N as Icon,
  k as iconCategories
};
//# sourceMappingURL=icon.js.map
